import {
    DeviceLayoutConfigSectionDetails,
    DeviceLayoutConfigSectionHeader,
    DeviceLayoutConfigSectionProperty,
} from 'modules/settings/pods/settings-devices/settings-devices-configuration/settings-devices-configuration-layout/settings-devices-configuration-layout.model';
import { PROPERTY_STATUS } from '../constants';

type IsPropertyHidden = (propertyName: DeviceLayoutConfigSectionProperty['name']) => boolean;

const sortByOrder = <T extends { order: number }>(items: T[]): T[] => items.toSorted((a, b) => a.order - b.order);

const isVisibleHeader = (header: DeviceLayoutConfigSectionHeader, isPropertyHidden: IsPropertyHidden): boolean =>
    !isPropertyHidden(header.name) && header.status !== PROPERTY_STATUS.HIDDEN;

const isVisibleProperty = (property: DeviceLayoutConfigSectionProperty, isPropertyHidden: IsPropertyHidden): boolean =>
    !isPropertyHidden(property.name) && property.status !== PROPERTY_STATUS.HIDDEN;

export const getVisibleHeaders = (
    sectionDetails: DeviceLayoutConfigSectionDetails,
    isPropertyHidden: IsPropertyHidden
): DeviceLayoutConfigSectionHeader[] =>
    sortByOrder(sectionDetails.headers.filter((header) => isVisibleHeader(header, isPropertyHidden)));

export const getVisibleProperties = (
    header: DeviceLayoutConfigSectionHeader,
    isPropertyHidden: IsPropertyHidden
): DeviceLayoutConfigSectionProperty[] =>
    sortByOrder(header.properties.filter((property) => isVisibleProperty(property, isPropertyHidden)));
